export default class LocalizeValue<T> {
  value: string;
  rawValue: T;

  constructor(rawValue: T, localize: (rawValue: T) => string) {
    this.value = localize(rawValue);
    this.rawValue = rawValue;
  }
}
